<template>
  <div class="log-manage-box" ref="aaa">
    <div class="log-condition-box">
      <el-radio-group v-model="clickDate" class="log-radio-box" @change="handlerRadioChange">
        <el-radio class="log-radio-item" v-model="clickDate" :border="false" size="mini" label="day">日</el-radio>
        <el-radio class="log-radio-item" v-model="clickDate" size="mini" label="week" >周</el-radio>
        <el-radio class="log-radio-item" v-model="clickDate" size="mini" label="month" >月</el-radio>
      </el-radio-group>
      <div class="log-pick-date">
        <!--<span class="demonstration">时间：</span>-->
        <el-date-picker
                v-model="chooseTimes"
                type="daterange"
                :picker-options="pickerOptions"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                @change="handleDateChange"
                align="right">
        </el-date-picker>
      </div>
      <div>
        <span class="operator-user-label">操作人</span>
        <el-autocomplete
                clearable
                size="small"
                class="inline-input"
                v-model="realName"
                value-key="value"
                :fetch-suggestions="querySearchAsync"
                placeholder=""
                @select="handleSelect"
        ></el-autocomplete>
      </div>
      <div class="log-search-button">
        <el-button size="small" style="background-color: white; color:#00A5B2" @click="fetchData()">查询</el-button>
      </div>
    </div>
    <flex>
      <el-table class="log-table" ref="table" size="small" @filter-change="handleFilterChange" :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)" width="100%" height="100%" :header-row-style="{color:'black'}" stripe>
        <el-table-column
                prop="userId"
                align="center"
                label="操作人">
        </el-table-column>
        <el-table-column
                prop="time"
                align="center"
                label="操作时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.time) }}
          </template>
        </el-table-column>
        <el-table-column
                prop="operation"
                align="center"
                label="操作分类"
                column-key="operation"
                :filters="operations"
        >
          <template slot-scope="scope">
            {{ operationMap[scope.row.operation] }}
          </template>
        </el-table-column>
        <el-table-column
                prop="ip"
                align="center"
                label="IP地址">
        </el-table-column>
        <el-table-column
                prop="system"
                align="center"
                label="功能模块">
        </el-table-column>
        <el-table-column
                prop="content"
                align="center"
                label="操作内容">
        </el-table-column>
      </el-table>
    </flex>
    <div class="log-page-box">
      <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100, 500, 1000]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.length">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import { getSysLogs } from '@/api/sysLog'
  import { getCustomerUsers } from '@/api/customerUser'
  import { getStartAndEnd, getCurrDayZero, getCurrDayLast } from '@/utils/time'
  import { formatToSecond } from '@/utils/time'
  import { Message, Loading } from 'element-ui'
  import { mapGetters } from 'vuex'
  import Flex from '@/components/Flex'
  export default {
    name: 'LogManage',
    components: {
      'flex': Flex
    },
    data() {
      return {
        pickerOptions: {
        },
        currentPage: 1,
        pagesize: 100,
        chooseTimes: [new Date(getCurrDayZero()), new Date(getCurrDayLast())],
        logs: [],
        tableData: [],
        // 条件
        condition: {
          sysLog: {
            customerId: '',
            operation: null,
            userId: null
          },
          startTime: getCurrDayZero(),
          endTime: getCurrDayLast()
        },
        // 操作分类
        operations: [
          { text: '查询', value: 'dbSelect' },
          { text: '保存', value: 'dbSave' },
          { text: '插入', value: 'dbInsert' },
          { text: '删除', value: 'dbDelete' },
          { text: '更新', value: 'dbUpdate' },
          { text: '登入', value: 'login' },
          { text: '登出', value: 'logout' },
          { text: '仪表操作', value: 'operation' }
        ],
        operationMap: {
        },
        // 点击粒度
        clickDate: 'day',
        realName: null,
        opFilters: []
      }
    },
    computed: {
      ...mapGetters([
        'customerId'
      ])
    },
    mounted() {
      this.fetchData()
      this.operations.forEach(item => {
        this.operationMap[item.value] = item.text
      })
    },
    watch: {
      realName: function(newVal, oldVal) {
        if (typeof newVal === 'undefined' || newVal === null || newVal === '') {
          this.condition.sysLog.userId = null
        }
      }
    },
    methods: {
      fetchData: function(isPage) {
        const aa = Loading.service({
          target: this.$refs.aaa,
          text: '数据加载中···'
        })
        if (this.chooseTimes.length > 0) {
          this.condition.startTime = this.chooseTimes[0].getTime()
          this.condition.endTime = getCurrDayLast(this.chooseTimes[1])
        }
        if (!isPage) {
          this.currentPage = 1
        }
        this.condition.sysLog.customerId = this.customerId
        getSysLogs(this.condition).then(res => {
          if (res.code === 200) {
            this.logs = res.infoJson
            this.resolveFilter()
            aa.close()
            // console.log(this.logs)
          }
        }).catch(error => {
          aa.close()
        })
      },

      formatTime: function(time) {
        if (typeof time !== 'undefined' && time !== null) {
          return formatToSecond(time)
        } else {
          return time
        }
      },
      handleSizeChange: function(size) {
        this.pagesize = size
      },
      handleCurrentChange: function(currentPage) {
        this.currentPage = currentPage
      },
      /**
       * 时间改变回调，范围不能大于30天
       * @param val
       */
      handleDateChange: function(val) {
        const diff = val[1].getTime() - val[0].getTime()
        if (diff > 30 * 24 * 60 * 60 * 1000) {
          Message({
            message: '时间范围不能大于30天',
            type: 'warning',
            duration: 3 * 1000
          })
          this.chooseTimes = [new Date(getCurrDayZero()), new Date(getCurrDayLast())]
        }
        this.clickDate = null
      },
      filterHandler: function(value, row, column) {
        // console.log(value)
        // console.log(row)
        // console.log(column)
        const property = column['property']
        return row[property] === value
      },
      handlerRadioChange: function(val) {
        const curr = getStartAndEnd('now', val)
        this.chooseTimes = [curr.start, curr.end]
        this.fetchData()
      },
      handleSelect: function(item) {
        this.condition.sysLog.userId = item.id
      },
      querySearchAsync: function(queryString, cb) {
        this.condition.customerId = this.customerId
        const condition = {
          customerId: this.customerId
        }
        const myPage = { page: { size: 1000000 }, condition: condition }
        getCustomerUsers(myPage).then(res => {
          if (res.code === 200) {
            const page = res.infoJson
            const final = typeof queryString !== 'undefined' && queryString !== null && queryString !== '' ? page.records.filter(item => {
              return item.realName.indexOf(queryString) !== -1
            }) : page.records
            cb(final.map(item => {
              return { id: item.id, value: item.realName }
            }))
          }
        }).catch(error => {
        })
      },
      // 过滤条件改变触发
      handleFilterChange: function(filters) {
        this.opFilters = filters['operation']
        this.resolveFilter()
      },
      resolveFilter: function() {
        const datas = []
        if (this.opFilters.length > 0) {
          this.logs.forEach(log => {
            this.opFilters.forEach(filter => {
              if (log.operation === filter) {
                datas.push(log)
              }
            })
          })
          this.currentPage = 1
          this.tableData = datas
        } else {
          this.tableData = this.logs
        }
      }
    }
  }
</script>

<style scoped rel="stylesheet/scss" lang="scss">
  .log-manage-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .log-condition-box {
      font-size: 14px;
      height: 60px;
      /*background-color: white;*/
      display: flex;
      align-items: center;
      /*padding-left: 30px;*/
      justify-content: flex-end;

      .log-radio-box {
        margin-right: 20px;
        display: flex;
        .log-radio-item {
          width: 60px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        justify-content: center;
        align-items: center;
      }

      .operator-user-label {
        margin-left: 20px;
        margin-right: 20px;
      }
      .log-search-button {
        margin-left: 10px;
      }
    }

    /* .log-table-box {
      flex:1;
    }*/

    .log-page-box {
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>

<style rel="stylesheet/scss" lang="scss">
  .el-table th {
    background-color: #f5fafb;
  }

  .log-condition-box {
    .el-radio__inner {
      display: none;
    }
    .el-radio+.el-radio {
     margin-left: 0;
    }

    .el-radio__label {
      padding-left: 0;
    }

    label.is-checked {
      background-color: white;
      border-radius: 20px;
    }
  }
</style>
